import { LargeGroup, Request } from 'types/shared/helper/reservations';

type RequestTime = Pick<Request, 'flexibleTime'> & {
  type?: string;
  time: string | null;
  timePreference?: LargeGroup['timePreference'];
};

export const hasConcreteTime = (time: unknown): time is string =>
  typeof time === 'string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(time);

export function waitinglistTime(entry: RequestTime, language = 'de'): string {
  if (hasConcreteTime(entry.time)) {
    return entry.time + (entry.flexibleTime
      ? ` (${entry.flexibleTime.earliest} - ${entry.flexibleTime.latest})`
      : '');
  }

  const english = language.startsWith('en');
  const french = language.startsWith('fr');
  const preference = entry.timePreference;
  const period = preference && (english
    ? { flex: 'Flexible', lunch: 'Lunch', dinner: 'Dinner' }
    : french
    ? { flex: 'Flexible', lunch: 'Déjeuner', dinner: 'Dîner' }
    : { flex: 'Flexibel', lunch: 'Mittags', dinner: 'Abends' })[preference];
  const pending = english ? 'Time to be agreed' : french ? 'Horaire à convenir' : 'Uhrzeit noch abzustimmen';
  const description = period ? `${period} · ${pending}` : pending;
  return description + (entry.flexibleTime
    ? ` (${entry.flexibleTime.earliest} - ${entry.flexibleTime.latest})`
    : '');
}

export function waitinglistSource(entry: {
  source: string;
  widgetContext?: { schemaVersion: number };
}): string {
  return entry.widgetContext?.schemaVersion === 1 ||
    entry.source === 'jan' || entry.source === 'jan-widget'
    ? 'JAN'
    : entry.source;
}
